import i18n from '@/translations';
import { mutationTypes } from './mutation-types';

export default {
  // 设置用户中心页面标题
  [mutationTypes.SET_MOBILERIGHTNAVSHOW](state, show) {
    state.mobileRightNavShow = show;
  },
  // 设置用户名
  [mutationTypes.SET_USERNAME](state, username) {
    state.username = username;
    username ? window.localStorage.setItem('username', username) : window.localStorage.removeItem('username');
  },
  // 设置token
  [mutationTypes.SET_TOKEN](state, token) {
    state.token = token;
    token ? window.localStorage.setItem('token', token) : window.localStorage.removeItem('token');
  },
  // 设置token过期时间
  [mutationTypes.SET_EXPIRETIME](state, expireTime) {
    state.expireTime = expireTime;
    expireTime ? window.localStorage.setItem('expireTime', expireTime) : window.localStorage.removeItem('expireTime');
  },
  // 设置最后更新时间
  [mutationTypes.SET_LASTUPDATETIME](state, lastUpdateTime) {
    state.lastUpdateTime = lastUpdateTime;
    lastUpdateTime
      ? window.localStorage.setItem('lastUpdateTime', lastUpdateTime)
      : window.localStorage.removeItem('lastUpdateTime');
  },
  // 设置当前语言
  [mutationTypes.SET_LANG](state, lang) {
    state.lang = lang;
    // i18n.locale = lang.code;
    lang && lang.code ? window.localStorage.setItem('lang', JSON.stringify(lang)) : window.localStorage.removeItem('lang');
    // lang && lang.code ? window.localStorage.setItem('lang', lang) : window.localStorage.removeItem('lang');
  },
  // 设置所有语言
  [mutationTypes.SET_LANGS](state, langs) {
    state.langs = langs;
  },
  [mutationTypes.SET_ASSETS](state, assetsList) {
    state.assetsList = assetsList;
  },
  // 设置交易市场
  [mutationTypes.SET_MARKETLIST](state, marketList) {
    state.marketList = marketList;
  },
  // 设置当前交易市场
  [mutationTypes.SET_CURRENTMARKET](state, currentMarket) {
    state.currentMarket = currentMarket;
  },
  // 设置用户详情信息
  [mutationTypes.SET_USERINFO](state, userInfo) {
    state.userInfo = userInfo;
  },
  [mutationTypes.SET_USER_VIP](state, userVip) {
    state.userVip = userVip;
  },
  // 设置货币类型
  [mutationTypes.SET_CURRENCY](state, currency) {
    state.currency = currency;
    if (currency) {
      window.localStorage.setItem('currency', JSON.stringify(currency));
    } else {
      window.localStorage.removeItem('currency');
    }
  },
  // 设置所有货币
  [mutationTypes.SET_CURRENCIES](state, currencies) {
    state.currencies = currencies;
  },
  // 设置所有货币
  [mutationTypes.SET_ALL_COIN](state, allCoin) {
    state.allCoin = allCoin;
  },
  // 设置未读消息数量
  [mutationTypes.SET_UNREADMESSAGECOUNT](state, messageCount) {
    state.unreadMessageCount = messageCount;
  },
  // 设置资讯研究二级导航
  [mutationTypes.SET_INFOMATIONNAV](state, infomationNav) {
    state.infomationNav = infomationNav;
  },
  // 设置socket连接状态
  [mutationTypes.SET_SOCKET_STATUS](state, socketStatus) {
    state.socketStatus = socketStatus;
  },
  // TIP 设置，币种列表
  [mutationTypes.SET_COIN_LIST](state, coinList) {
    state.coinList = coinList;
  },
  // 设置，移动端侧滑菜单显示与隐藏
  [mutationTypes.SET_SLIDERMENUCONTROLS](state, typeAndVal) {
    let arr = typeAndVal.split('-');
    let type = arr[0];
    let val = arr[1] === 'true';

    state.sliderMenuControls[type] = val;
  },
  // TIP 设置，所有币币交易对，列表
  [mutationTypes.SET_TRADING_PAIRS_LIST](state, tradingPairsList) {
    state.tradingPairsList = tradingPairsList;
  },
  // TIP 设置，收藏的交易对id列表
  [mutationTypes.SET_COLLECTED_MARKETS_SYMBOLS](state, symbols) {
    if ({}.toString.call(symbols) !== '[object Object]') {
      console.error('mutation 设置收藏的交易对 symbols必须是一个对象！');
      return;
    }
    for (let attr in symbols) {
      let val = symbols[attr];
      if (val === -1) {
        delete state.collectedMarketSymbols[attr];
      } else {
        state.collectedMarketSymbols[attr] = 1;
      }
    }
  },
  [mutationTypes.SET_FOR_MOBILE](state, forMobile) {
    state.forMobile = forMobile;
  },
  [mutationTypes.SET_SOCKET_STATE](state, socketState) {
    state.socketState = socketState;
  },
  [mutationTypes.SET_BURGER_MENU_STATE](state, burgerMenuState) {
    if (burgerMenuState !== null && burgerMenuState !== undefined) {
      state.burgerMenuState = burgerMenuState;
    }
  },
  [mutationTypes.SET_WECHAT_QRCODE_STATE](state, wechatQrCode) {
    if (wechatQrCode !== null && wechatQrCode !== undefined) {
      state.wechatQrCode = wechatQrCode;
    }
  },
  [mutationTypes.SET_AFFILIATE_PARTNER_INFO](state, afAndPrInfo) {
    state.afAndPrInfo = afAndPrInfo;
  },
  [mutationTypes.SET_PARTNER_INFO](state, partnerInfo) {
    state.partnerInfo = partnerInfo;
  },
  [mutationTypes.SET_PARTNER_TYPE](state, type) {
    state.partnerType = type;
  },
  [mutationTypes.SET_AFFILIATE_TYPE](state, type) {
    state.affiliateType = type;
  },
  [mutationTypes.SET_REWARD_CATEGORIES](state, categories) {
    state.rewardCategories = categories;
  },
};
